var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMutedVdoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 93.5469,
    y: 28,
    width: 537.017,
    height: 15.0546,
    transform: "rotate(56.4543 93.5469 28)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.3049 107.425C85.0411 109.076 71.6654 115.491 61.4112 125.745C49.4089 137.747 42.666 154.026 42.666 171V341.667C42.666 358.641 49.4089 374.919 61.4112 386.921C73.4135 398.924 89.6922 405.667 106.666 405.667H297.049L99.3049 107.425ZM349.606 380.411C358.031 369.335 362.666 355.74 362.666 341.667V310.733L408.746 353.4C415.53 359.541 424.343 362.959 433.493 363C438.571 362.988 443.588 361.897 448.213 359.8C454.505 357.255 459.895 352.891 463.695 347.267C467.495 341.643 469.532 335.014 469.546 328.227V184.44C469.515 177.628 467.447 170.981 463.607 165.354C459.767 159.728 454.331 155.379 447.999 152.867C441.518 149.948 434.321 148.999 427.304 150.137C420.288 151.275 413.76 154.449 408.533 159.267L362.666 201.933V171C362.666 154.026 355.923 137.747 343.921 125.745C331.919 113.743 315.64 107 298.666 107H168.326L349.606 380.411Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMutedVdoIcon);
export default __webpack_public_path__ + "static/media/muted_vdo_icon.37fe66aca40347b876795d6ad8969123.svg";
export { ForwardRef as ReactComponent };